import {useForm} from 'react-hook-form';

export interface FeedbackForm {
  text: string;
  rating: number;
}

export const useFeedbackForm = () => {
  return useForm<FeedbackForm>({
    mode: 'onChange',
    defaultValues: {
      text: '',
      rating: 0,
    },
    shouldUnregister: true,
  });
};
